import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DialogService } from '../_services/dialog.service';
import { HttpClient, HttpRequest, HttpEventType, HttpResponse, HttpHeaders } from '@angular/common/http';

import { UserService } from '../_services/user.service';

import { NgxSpinnerService } from 'ngx-spinner';
import { JWTTokenService } from '../_services/jwtToken.service';
import { FundraisingService } from '../_services/fundraising/fundraising.service';
import { FundraiserListView } from '../_models/fundraising/Fundraiser';
import { Cue5050 } from '../_models/fundraising/Cue5050';
import { Cue5050Service } from '../_services/fundraising/cue5050.service';
import { ChooseWinningTicketModalComponent } from './cue5050/choose-winning-ticket-modal.component';
import { VerifyTicketModalComponent } from './cue5050/verify-winning-ticket-modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { EventDetailsModalComponent } from './cue5050/event-details-modal.component';

@Component({
  selector: 'app-fundraising-management',
  templateUrl: './fundraising-management.component.html',
  styleUrls: ['./fundraising-management.component.css']
})

export class FundraisingManagementComponent implements OnInit  {

  cue5050s: Cue5050[] = [];
  displayItems: Cue5050[] = [];

  loading = false;
  searchText: string;

  private bsModalRef: BsModalRef;

  constructor(
    private cue5050Service: Cue5050Service,
    private router: Router,
    private viewRef: ViewContainerRef,
    private dialogService: DialogService,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.loadFundraisers();
  }

  loadFundraisers() {
    this.loading = true;
    this.spinner.show();

    this.cue5050Service.getAll().subscribe(f => {
      const sorted = f.cue5050s.filter(a => a.event.active);
      this.orderByInProgress(sorted);
      this.cue5050s = sorted.reverse();
      this.displayItems = sorted;
      this.loading = false;
      this.spinner.hide();
    },
    error => {   
      this.loading = false;
      this.spinner.hide();

      if (!error) return;

      this.dialogService.alert(
        'Uh oh something went wrong...', 
        `Unable to load fundraisers: ${error.error}`,
        this.viewRef);

    });
  }

  public create() {
    this.router.navigate([`/portal/fundraising/cue5050/event/cue5050`]);
  }

  edit(objectId: number) {
    this.router.navigate([`/portal/fundraising/cue5050/event/cue5050/`, objectId]);
  }

  clone(objectId: number){
    this.router.navigate([`portal/fundraising/cue5050/event/cue5050/`, objectId], {  queryParams: {c: 'true'}})
  }

  public search() {

    this.displayItems = Array.from(this.cue5050s);

    if (!this.searchText) {
      return;
    }
    
    let quoteRegex = /[^\s"]+|"([^"]*)"/gi;
    let searchTerms = [];
    let match;

    do {

      match = quoteRegex.exec(this.searchText.toLowerCase());

      if (match != null) {
        searchTerms.push(match[1] ? match[1] : match[0]);
      }

    } while (match != null);


    let filtered = [];

    searchTerms.forEach(s => {
      const f = this.displayItems.filter(d =>
        (d.event.name ? d.event.name.toLowerCase().indexOf(s) !== -1 : false) ||
        (d.event.merchant.name ? d.event.merchant.name.toLowerCase().indexOf(s) !== -1 : false) ||
        (d.event.vendor.name ? d.event.vendor.name.toLowerCase().indexOf(s) !== -1 : false) ||
        (d.event.location.name ? d.event.location.name.toLowerCase().indexOf(s) !== -1 : false) ||
        !s);

      f.forEach(y => {
        filtered.push(y);
        this.displayItems.splice(this.displayItems.indexOf(y), 1);
      })
    });

    this.displayItems = filtered;

  }

  orderByInProgress(events: Cue5050[]){
    events.sort((a, b) => {
      if (a.event.status === 2){
          return 1;
      }else if (b.event.status === 2){
          return -1;
      }else if (a.event.status === 1){
          return 1;
      }else if (b.event.status === 1){
          return -1;
      }else {
          return b.event.status - a.event.status;
      }
    })
}

  startEvent(id: number) {
    this.dialogService.confirm(
      'Ready to go?',
      'Are you sure you want to start this event? Once the event starts, it can no longer be canceled.',
      this.viewRef)
        .then((result) => {
          if (result === true) {

            this.loading = true;
            this.spinner.show();

            this.cue5050Service.startEvent(id)
              .subscribe(
                ()=> {

                  this.loading = false;
                  this.spinner.hide();

                  this.dialogService.alert(
                    'Event Started',
                    'Your event has been started!',
                    this.viewRef).then(() => {
                      this.loadFundraisers();
                    });
                },
                error => {
                  this.dialogService.alert(
                    'Uh oh something isn\'t right here...',
                    `We were unable to start your event. Please contact support at support@connectwithcue.com. ${error.error}`,
                    this.viewRef);

                    this.loading = false;
                    this.spinner.hide();
                });     
          }
        });
  }

  drawWinner(id: number) {
    this.dialogService.confirm(
      'Here we go!',
      'Are you sure you want to draw a winner for this event?',
      this.viewRef)
        .then((result) => {
          if (result === true) {

            this.loading = true;
            this.spinner.show();

            this.cue5050Service.drawWinner(id)
              .subscribe(
                ()=> {

                  this.loading = false;
                  this.spinner.hide();

                  this.dialogService.alert(
                    'Winner Drawn',
                    'The winning ticket has been drawn!',
                    this.viewRef).then(() => {
                      this.loadFundraisers();
                    });
                },
                error => {
                  this.dialogService.alert(
                    'Uh oh something isn\'t right here...',
                    `We were unable to draw a winner. Please contact support at support@connectwithcue.com. ${error.error}`,
                    this.viewRef);

                    this.loading = false;
                    this.spinner.hide();
                });     
          }
        });
  }

  setVerification(eventId: number) {
    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      eventId
    };

    this.bsModalRef = this.modalService
      .show(
          VerifyTicketModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-md', initialState })
      );

    

    this.bsModalRef.content.hasError.subscribe(
        value => {
          if (value) {
            this.dialogService.alert('Uh oh, not good!', `There was an error while trying to verify the winner.`, this.viewRef);
          } else {
            this.dialogService.alert('Winner Verified', `The winner has been verified.`, this.viewRef).then(() => {
              this.loadFundraisers();
            });
          }
      });
  }

  openChooseWinnerModal(eventId: number) {
    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      eventId: eventId
    };

    this.bsModalRef = this.modalService
      .show(
          ChooseWinningTicketModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-md', initialState })
      );

    this.bsModalRef.content.hasError.subscribe(
        value => {
          if (value) {
            this.dialogService.alert('Uh oh, not good!', `There was an error while trying to set a the winner. The ticket number may not match the reference number provided. Please contact support@connectwithcue.com if you continue to encounter this error`, this.viewRef);
          } else {
            this.dialogService.alert('Winner Chosen', `The winning ticket has been set`, this.viewRef).then(() => {
              this.loadFundraisers();
            });
          }
      });
  }

  cancelEvent(id: number) {
    this.dialogService.confirm(
      'Uh oh',
      'Are you sure you want to cancel this event? This action is irreversible.',
      this.viewRef)
        .then((result) => {
          if (result === true) {

            this.loading = true;
            this.spinner.show();

            this.cue5050Service.cancelEvent(id)
              .subscribe(
                ()=> {

                  this.loading = false;
                  this.spinner.hide();

                  this.dialogService.alert(
                    'Event Started',
                    'Your event has been canceled',
                    this.viewRef).then(() => {
                      this.loadFundraisers();
                    });
                },
                error => {
                  this.dialogService.alert(
                    'Uh oh something isn\'t right here...',
                    `We were unable to start your event. Please contact support at support@connectwithcue.com. ${error.error}`,
                    this.viewRef);
        
                    this.loading = false;
                    this.spinner.hide();
                }
            );     
          }
      });   
  }

  completeEvent(id: number) {
    this.dialogService.confirm(
      'Ready to wrap it up?',
      'Are you sure you want to complete this event? This action is irreversible.',
      this.viewRef)
        .then((result) => {
          if (result === true) {

            this.loading = true;
            this.spinner.show();

            this.cue5050Service.completeEvent(id)
              .subscribe(
                ()=> {

                  this.loading = false;
                  this.spinner.hide();

                  this.dialogService.alert(
                    'Event Completed',
                    'Your event has been completed and closed! You can now draw a winning ticket.',
                    this.viewRef).then(() => {
                      this.loadFundraisers();
                    });
                },
                error => {
                  this.dialogService.alert(
                    'Uh oh something isn\'t right here...',
                    `We were unable to complete your event. Please contact support at support@connectwithcue.com. ${error.error}`,
                    this.viewRef);

                    this.loading = false;
                    this.spinner.hide();
                }
            );     
          }
      });
  }

  openDetailsModal(cue5050Id: number){
    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      cue5050Id,
      viewRef: this.viewRef
    };

    this.bsModalRef = this.modalService
      .show(
        EventDetailsModalComponent,
        Object.assign({}, modalConfig, { class: 'modal-md', initialState }));
  }

  formatTime(t: string) {
    const d = new Date(); 

    const hms = t.split(':');
    d.setHours(+hms[0] || 0);
    d.setMinutes(+hms[1] || 0);

    return d;
  }

}
